import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';

export const MAP_LIBRARY_SLICE_KEY = 'mapLibrary';

export function createMapLibrarySlice() {
  return createSlice({
    name: MAP_LIBRARY_SLICE_KEY,
    initialState: {
      mapLibraryStatus: LoadingStatus.Idle.toString(),
      mapLibraryError: null,
    },
    reducers: {
      mapLibraryFetch: (state) => {
        state.mapLibraryStatus = LoadingStatus.Loading.toString();
        state.mapLibraryError = null;
      },
      mapLibraryLoaded: (state) => {
        state.mapLibraryStatus = LoadingStatus.Succeeded.toString();
        state.mapLibraryError = null;
      },
      mapLibraryErrored: (state, action) => {
        state.mapLibraryStatus = LoadingStatus.Failed.toString();
        state.mapLibraryError = action.payload;
      },
    },
  });
}
